export const SITE_SETTINGS_MEDIA_BUCKET = 'strashin-developments-media';
// Shared bucket total cap (policy).
export const SITE_SETTINGS_MEDIA_BUCKET_MAX_BYTES = 200 * 1024 * 1024 * 1024; // 200GB total
// Supabase upload cap per file for the dashboard flow.
export const SITE_SETTINGS_MEDIA_MAX_BYTES = 5 * 1024 * 1024 * 1024; // 5GB per file
export const SITE_SETTINGS_MEDIA_ALLOWED_TYPES = [
  'image/jpeg',
  'image/png',
  'image/webp',
  'image/heic',
  'image/heif',
  'video/mp4',
  'video/webm',
  'video/quicktime',
];
export const SITE_SETTINGS_MEDIA_PUBLIC_BASE_PATH = 'site-settings/home-hero';
